/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerVerticalCompatibilityWithStrategyInner } from './';
import {
    FreelancerVerticalCompatibilityWithStrategyInnerFromJSON,
    FreelancerVerticalCompatibilityWithStrategyInnerFromJSONTyped,
    FreelancerVerticalCompatibilityWithStrategyInnerToJSON,
} from './';
import type { FreelancerVerticalStateInner } from './';
import {
    FreelancerVerticalStateInnerFromJSON,
    FreelancerVerticalStateInnerFromJSONTyped,
    FreelancerVerticalStateInnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerVerticalStateResource
 */
export interface FreelancerVerticalStateResource {
    /**
     * 
     * @type {Array<FreelancerVerticalStateInner>}
     * @memberof FreelancerVerticalStateResource
     */
    state: Array<FreelancerVerticalStateInner>;
    /**
     * 
     * @type {Array<FreelancerVerticalCompatibilityWithStrategyInner>}
     * @memberof FreelancerVerticalStateResource
     */
    compatibilityWithStrategy: Array<FreelancerVerticalCompatibilityWithStrategyInner>;
}

/**
 * Check if a given object implements the FreelancerVerticalStateResource interface.
 */
export function instanceOfFreelancerVerticalStateResource(value: object): value is FreelancerVerticalStateResource {
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('compatibilityWithStrategy' in value) || value['compatibilityWithStrategy'] === undefined) return false;
    return true;
}

export function FreelancerVerticalStateResourceFromJSON(json: any): FreelancerVerticalStateResource {
    return FreelancerVerticalStateResourceFromJSONTyped(json, false);
}

export function FreelancerVerticalStateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerVerticalStateResource {
    if (json == null) {
        return json;
    }
    return {
        
        'state': ((json['state'] as Array<any>).map(FreelancerVerticalStateInnerFromJSON)),
        'compatibilityWithStrategy': ((json['compatibilityWithStrategy'] as Array<any>).map(FreelancerVerticalCompatibilityWithStrategyInnerFromJSON)),
    };
}

export function FreelancerVerticalStateResourceToJSON(value?: FreelancerVerticalStateResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'state': ((value['state'] as Array<any>).map((v) => FreelancerVerticalStateInnerToJSON(v))),
        'compatibilityWithStrategy': ((value['compatibilityWithStrategy'] as Array<any>).map((v) => FreelancerVerticalCompatibilityWithStrategyInnerToJSON(v))),
    };
}

